import { render } from "./TemplateDescriptionModal.vue?vue&type=template&id=2e6e6c6e&lang=pug"
import script from "./TemplateDescriptionModal.vue?vue&type=script&lang=js"
export * from "./TemplateDescriptionModal.vue?vue&type=script&lang=js"

import "./TemplateDescriptionModal.vue?vue&type=style&index=0&id=2e6e6c6e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__